import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { ProjectTypeScreenBehavior } from 'app/shared/models';
import { NameValue } from 'app/shared/models/name-value';

export class ScreenBehaviorData {
  constructor(public formControlMap: Map<string, NameValue<AbstractControl>>,
    public form: UntypedFormGroup, public formControlMapReverse: Map<string, string>,
    public visibility: { [key: string]: boolean } = {},
    public formConfig: { [key: string]: any },
    public overrides: ProjectTypeScreenBehavior[]) { }
}